<template>
  <action-dialog
      v-model="fieldValue"
      :data="form"
      :edit-mode="false"
      dialog-max-width="500"
      submit-title="Imposta prezzo finale e nota"
      submit-success-message="Prezzo aggiornato con successo!"
      :fields="fields"
      :field-default-options="fieldDefaultOptions"
      :submit-promise-callback="submitPurchase"
      @close="close"
  >
    <template #field.finalPrice="{ label, classes }">
      <price-input
          v-model="form.finalPrice"
          :classes="classes"
          :label="label"
          outlined
      />
    </template>

    <template #field.note="{ errors, label, classes }">
      <v-textarea
          v-model="form.note"
          :label="label"
          :class="classes"
          :error-messages="errors"
          auto-grow
          outlined
          rows="2"
      />
    </template>
  </action-dialog>
</template>

<script>
import ActionDialog from '@/components/ActionDialog/ActionDialog'
import PriceInput from '@/components/Field/PriceInput'

export default {
  name: 'PaniereProductPurchaseDialog',
  components: { ActionDialog, PriceInput },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    userId: {
      type: [String, Number],
      required: true
    },
    paniereProduct: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      fieldDefaultOptions: { lessMargin: true, cols: 12 },
      fields: [
        { value: 'finalPrice', label: 'Prezzo finale', rules: 'required|min_value:0', cols: 12 },
        { value: 'note', label: 'Nota', rules: 'max:512', cols: 12 }
      ],
      form: {
        finalPrice: null,
        note: ''
      }
    }
  },
  computed: {
    fieldValue: {
      get () {
        return !!this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  watch: {
    value (newVal) {
      if (newVal && this.paniereProduct) {
        // Prefill with existing finalPrice when present; otherwise fallback to totalPrice
        this.form.finalPrice = (this.paniereProduct.finalPrice != null ? this.paniereProduct.finalPrice : this.paniereProduct.totalPrice) || 0
        this.form.note = this.paniereProduct.note || ''
      }
    }
  },
  methods: {
    async submitPurchase () {
      const paniereProductId = this.paniereProduct.id
      await this.$http.patch(
        `v1/distribution/users/${this.userId}/paniere-products/${paniereProductId}/purchase`,
        {
          finalPrice: this.form.finalPrice,
          note: this.form.note
        }
      )
      // Emit success so parent can refresh data
      this.$emit('success')
    },
    close () {
      this.fieldValue = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
